( function () {
	'use strict';

	function initialiseCarousel( carousel ) {
		var track = carousel.querySelector( '[data-featured-products-track]' );
		var section = carousel.closest( 'section' );
		var controls = section ? section.querySelector( '[data-featured-products-controls]' ) : null;
		var interactionArea = section || carousel;

		if ( ! track || ! controls ) {
			return;
		}

		var cards = Array.from( track.children );
		var previousButton = controls.querySelector( '[data-featured-products-previous]' );
		var nextButton = controls.querySelector( '[data-featured-products-next]' );
		var reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
		var canHover = window.matchMedia( '(hover: hover)' );
		var frame;
		var timer;
		var transitionTimer;
		var interactionTimer;
		var moving = false;
		var userInteracting = false;

		if ( cards.length < 2 || ! previousButton || ! nextButton ) {
			return;
		}

		controls.classList.remove( 'hidden' );
		controls.classList.add( 'flex' );

		function cardStep() {
			var firstCard = track.firstElementChild;
			var styles = window.getComputedStyle( track );
			var gap = parseFloat( styles.columnGap || styles.gap ) || 0;

			return firstCard ? firstCard.getBoundingClientRect().width + gap : 0;
		}

		function updateControls() {
			var maximum = Math.max( 0, track.scrollWidth - track.clientWidth );
			var hasOverflow = maximum > 1;

			controls.classList.toggle( 'invisible', ! hasOverflow );
			previousButton.disabled = ! hasOverflow;
			nextButton.disabled = ! hasOverflow;
		}

		function move( direction ) {
			var step = cardStep();
			var start;
			var finishMove;
			var scrollEndHandler;

			if ( moving || ! step ) {
				return;
			}

			moving = true;
			window.clearTimeout( transitionTimer );
			start = Math.round( track.scrollLeft / step ) * step;
			start = Math.max( 0, Math.min( start, track.scrollWidth - track.clientWidth ) );

			// Never carry a fractional or interrupted touch-scroll offset into the
			// next automatic movement. That drift was able to clip the card edge.
			if ( Math.abs( track.scrollLeft - start ) > 0.5 ) {
				track.scrollLeft = start;
			}

			if ( 0 < direction && track.scrollWidth - track.clientWidth - start < step - 1 ) {
				track.append( track.firstElementChild );
				start = Math.max( 0, start - step );
				track.scrollLeft = start;
			} else if ( 0 > direction ) {
				track.prepend( track.lastElementChild );
				track.scrollLeft = start + step;
			}

			finishMove = function () {
				if ( ! moving ) {
					return;
				}

				track.removeEventListener( 'scrollend', scrollEndHandler );
				window.clearTimeout( transitionTimer );
				if ( 0 < direction ) {
					track.append( track.firstElementChild );
					track.scrollLeft = start;
				}
				moving = false;
				updateControls();
				startTimer();
			};
			scrollEndHandler = finishMove;

			if ( ! reducedMotion.matches ) {
				track.addEventListener( 'scrollend', scrollEndHandler, { once: true } );
			}

			track.scrollTo( {
				left: 0 < direction ? start + step : start,
				behavior: reducedMotion.matches ? 'auto' : 'smooth'
			} );

			if ( reducedMotion.matches ) {
				window.requestAnimationFrame( finishMove );
			} else {
				// Safari versions without scrollend still need a safe completion path.
				// This is deliberately longer than a typical native smooth scroll.
				transitionTimer = window.setTimeout( finishMove, 1200 );
			}
		}

		function stopTimer() {
			window.clearTimeout( timer );
		}

		function startTimer() {
			stopTimer();
			if ( document.hidden || nextButton.disabled || moving || userInteracting || reducedMotion.matches || ! canHover.matches ) {
				return;
			}
			timer = window.setTimeout( function () {
				move( 1 );
			}, 4000 );
		}

		function setUserInteraction( active, delay ) {
			window.clearTimeout( interactionTimer );
			if ( active ) {
				userInteracting = true;
				stopTimer();
				return;
			}

			interactionTimer = window.setTimeout( function () {
				userInteracting = false;
				startTimer();
			}, delay || 0 );
		}

		function navigate( direction ) {
			move( direction );
			startTimer();
		}

		previousButton.addEventListener( 'click', function () { navigate( -1 ); } );
		nextButton.addEventListener( 'click', function () { navigate( 1 ); } );
		document.addEventListener( 'visibilitychange', startTimer );
		interactionArea.addEventListener( 'mouseenter', function () {
			if ( canHover.matches ) {
				setUserInteraction( true );
			}
		} );
		interactionArea.addEventListener( 'mouseleave', function () {
			if ( canHover.matches ) {
				setUserInteraction( false );
			}
		} );
		interactionArea.addEventListener( 'focusin', function () { setUserInteraction( true ); } );
		interactionArea.addEventListener( 'focusout', function () {
			window.setTimeout( function () {
				if ( ! interactionArea.contains( document.activeElement ) ) {
					setUserInteraction( false );
				}
			}, 0 );
		} );
		track.addEventListener( 'pointerdown', function () { setUserInteraction( true ); }, { passive: true } );
		track.addEventListener( 'pointerup', function () { setUserInteraction( false, 6000 ); }, { passive: true } );
		track.addEventListener( 'pointercancel', function () { setUserInteraction( false, 6000 ); }, { passive: true } );
		track.addEventListener( 'wheel', function () {
			setUserInteraction( true );
			setUserInteraction( false, 6000 );
		}, { passive: true } );
		track.addEventListener( 'scroll', function () {
			window.cancelAnimationFrame( frame );
			frame = window.requestAnimationFrame( updateControls );
		}, { passive: true } );

		if ( 'ResizeObserver' in window ) {
			new ResizeObserver( function () {
				updateControls();
				startTimer();
			} ).observe( track );
		} else {
			window.addEventListener( 'resize', function () {
				updateControls();
				startTimer();
			} );
		}

		updateControls();
		startTimer();
	}

	document.querySelectorAll( '[data-featured-products-carousel]' ).forEach( initialiseCarousel );
}() );
